export default __webpack_public_path__ + "static/media/Bluetux.5f8144db.png";